<template>
  <section></section>
</template>

<script>
export default {
  name: 'lectorCodigosBarras',
  props: ['desactivado'],
  data() {
    return {
      contador: 0,
      codigo: '',
    };
  },
  created() {
    window.addEventListener('keyup', this.handler);
  },
  methods: {
    reiniciarLectura() {
      this.contador = 0;
      this.codigo = '';
    },
    handler(e) {
      const self = this;

      if (e.key == 'Enter') {
        self.$emit('codigoLeido', this.codigo);
        self.reiniciarLectura();
      } else {
        this.codigo += e.key;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handler);
  },
  watch: {
    desactivado() {
      if (!!this.desactivado) {
        window.removeEventListener('keyup', this.handler);
      } else {
        setTimeout(() => {
          window.addEventListener('keyup', this.handler);
        }, 500);
      }
    },
  },
};
</script>
